import type { LDClient } from 'launchdarkly-react-client-sdk';
import { DEFAULT_FLAGS } from '../default-flags';

// Simple in-memory override store
export const flagOverrides: Record<string, boolean | string | number> = {};

/**
 * Export global feature flag functions for console access.
 * @remarks Avoid using `any` type where possible.
 */
interface GlobalFlagFunctions {
  set: (flagKey: string, value: boolean | string | number) => void;
  clear: (flagKey: string) => void;
  clearAll: () => void;
  list: () => void;
}

// Attach global feature flag console helpers if not present
declare global {
  interface Window {
    ff?: GlobalFlagFunctions;
  }
}

export function initializeOverrideInterface(ldClient?: LDClient) {
  window.ff = {
    set: (flagKey: string, value: boolean | string | number) => {
      flagOverrides[flagKey] = value;
      console.log(`✅ Flag override set: ${flagKey} = ${value}`);
      console.log('Current overrides:', { ...flagOverrides });
      // Trigger re-render by dispatching a custom event
      window.dispatchEvent(new CustomEvent('flag-override-changed'));
    },
    clear: (flagKey: string) => {
      delete flagOverrides[flagKey];
      console.log(`✅ Flag override cleared: ${flagKey}`);
      console.log('Current overrides:', { ...flagOverrides });
      window.dispatchEvent(new CustomEvent('flag-override-changed'));
    },
    clearAll: () => {
      for (const key of Object.keys(flagOverrides)) {
        delete flagOverrides[key];
      }
      console.log('✅ All flag overrides cleared');
      window.dispatchEvent(new CustomEvent('flag-override-changed'));
    },
    list: () => {
      const allFlags = ldClient?.allFlags() || {};
      console.log('🎌 All flags:', allFlags);
      console.log('🔧 Overrides:', { ...flagOverrides });
      console.log('🔧 Defaults:', DEFAULT_FLAGS);
    },
  };
}
